import type { IconSvgObject } from './types';

const CopyXIcon: IconSvgObject = [
  ["path", { d: "M7 16.002V4.00195C7 2.89738 7.89543 2.00195 9 2.00195H19C20.1046 2.00195 21 2.89738 21 4.00195V16.002C21 17.1065 20.1046 18.002 19 18.002H9C7.89543 18.002 7 17.1065 7 16.002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 7.50195L16.5 12.502M16.5 7.50195L11.5 12.502", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 6.00195V20.002C3 21.1065 3.89543 22.002 5 22.002H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CopyXIcon;
